export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7607.9adf2c79.jpg";